const SearchWidget = () => import('@/views/widgets/SearchWidget');

const searchWidget = [
  {
    title: 'Search Widget',
    path: '/admin/search/:keywords',
    component: SearchWidget,
  }
]

export default searchWidget.map(data => {
  const { path, title, component, redirect, children } = data

  return {
    path: path,
    name: title,
    component: component,
    redirect: redirect,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})